import { render } from "./TrailerItem.vue?vue&type=template&id=27db8e8a&scoped=true"
import script from "./TrailerItem.vue?vue&type=script&lang=js"
export * from "./TrailerItem.vue?vue&type=script&lang=js"

import "./TrailerItem.vue?vue&type=style&index=0&id=27db8e8a&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27db8e8a"]])

export default __exports__